// CSV export — serialise table data to a downloadable .csv file.
//
// Pure client-side: the rows are already in the React Query cache, so export
// needs no backend endpoint. bigint values (money in paise — CLAUDE.md rule 6)
// are stringified, since CSV is text and Papa.unparse cannot serialise bigint.
import Papa from "papaparse";

/**
 * downloadCsv — turn an array of flat records into a CSV file and trigger a
 * browser download. Column order follows the keys of the first row.
 */
export function downloadCsv(
  filename: string,
  rows: Record<string, unknown>[],
): void {
  const normalised = rows.map((row) => {
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(row)) {
      out[key] = typeof value === "bigint" ? value.toString() : value;
    }
    return out;
  });

  const csv = Papa.unparse(normalised);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveBlob(filename, blob);
}

/**
 * saveBlob — turn any Blob into a downloaded file. Extracted from
 * downloadCsv so server-driven binary downloads (the Reports page's
 * CSV/JSON/XLSX streams) can reuse the same dance: create a temp
 * Object URL, click a hidden <a>, revoke. Browsers free the underlying
 * blob storage when the URL is revoked.
 */
export function saveBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
